import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

export function getDataByCustmerId(customerId) {
  return request({
    url: cmsServerContext + '/customerPushUrl/list/'+ customerId,
    method: 'get',
  })
}

export function getTree(customerId) {
  return request({
    url: cmsServerContext + '/customerPushUrl/getMeterTree/'+ customerId,
    method: 'get',
  })
}

export function getMeasureType() {
  return request({
    url: cmsServerContext + '/customerPushUrl/measureTypeTree',
    method: 'get',
  })
}

export function getWaringType() {
  return request({
    url: cmsServerContext + '/customerPushUrl/getWarningType',
    method: 'get',
  })
}

export function saveOrUpdate(data) {
  return request({
    url: cmsServerContext + '/customerPushUrl/save',
    method: 'post',
    data: data
  })
}

export function del(data) {
  return request({
    url: cmsServerContext + '/customerPushUrl/delete',
    method: 'post',
    data: data
  })
}